import { useState } from "react";
import {Container } from "@material-ui/core";
import SettingsStoreItem from "../components/settingsComponents/SettingsStoreItem";
import SettingsList from "../components/settingsComponents/SettingsList";
import { Dialog, DialogContent, DialogActions, Button } from '@mui/material';
import { CheckCircleOutline } from '@mui/icons-material';
import useSettings from "../hooks/useSettings";
import Loading from "../components/Loading";
import useLoading from "../hooks/useLoading";
import SettingsExclusionIngest from "../components/settingsComponents/exclusion/SettingsExclusionIngest";
import SettingsExclusionLicensePlate from "../components/settingsComponents/exclusion/SettingsExclusionLicensePlate";
import useStore from "../hooks/useStore";

const Settings = (props) => {
  const { history } = props;
  const { isLoading } = useLoading();
  const [showList, setShowList] = useState(true);
  const [showModal, setShowModal] = useState(false);
  const { settingsData, setSettingSelected, updateSetting, settingSelected } = useSettings();
  const { STATE_CODES } = useStore();
  const [confirmationModal, setConfirmationModal] = useState(false)

  const closeModal = () => {
    setShowModal(false);
  };

  const redirectToHome = () => {
    history.push('/home')
  }
  const closeList = () => {
    setShowList(true)
  }

  const openSuccessModal = () => {
    setShowModal(true)
  }

  const renderDetailComponent = () => {
    if (settingSelected.key === 'INGEST_PRODUCT_EXCLUSION') {
      return (
        <SettingsExclusionIngest
          onClose={closeList}
          openSuccessModal={openSuccessModal}
          updateSetting={updateSetting}
          settingSelected={settingSelected}
        />
      )
    } else if (settingSelected.key === 'LICENSE_PLATE_EXCLUSION') {
      return (
        <SettingsExclusionLicensePlate
          onClose={closeList}
          openSuccessModal={openSuccessModal}
          updateSetting={updateSetting}
          settingSelected={settingSelected}
          storeStateCodes={STATE_CODES}
        />
      )
    } else {
      return (
        <SettingsStoreItem
          onClose={closeList}
          openSuccessModal={openSuccessModal}
          redirectToHome={redirectToHome}
          updateSetting={updateSetting}
          settingSelected={settingSelected}
          confirmationModal={confirmationModal}
          setConfirmationModal={setConfirmationModal}
        />
      )
    }
  }

  return (
    <Container 
    maxWidth='md'
    sx={{ alignItems: "flex-end", marginBottom: '40px', backgroundColor:'white'}}
  >
    {
      showList ?
        <SettingsList 
          setShowList={setShowList} 
          redirectToHome={redirectToHome}
          settingsData={settingsData}
          setSettingSelected={setSettingSelected}
        />
      :
        renderDetailComponent()
    }
    {
      showModal && 
      <Dialog
        sx={{ '& .MuiDialog-paper': { width: '80%', maxHeight: 435, backgroundColor: '#edf7ed', color: '#1e4620', fontWeight: 400 } }}
        maxWidth="xs"
        open={openSuccessModal}
      >
          <DialogContent sx={{display: 'flex', alignItems: 'center'}}>
              <CheckCircleOutline fontSize='large' sx={{mr: 2}}/>
              Your selection has been saved.
          </DialogContent>
          <DialogActions>
              <Button onClick={closeModal} autoFocus sx={{color: '#1e4620'}}>
                  Close
              </Button>
          </DialogActions>
      </Dialog>
    }
    {isLoading ? <Loading/> : null}
    </Container>
  );
};

export default Settings;
